import {Route} from "react-router";
import AdminUserListView from "./admin/AdminUserListView";
import AdminUserView from "./admin/AdminUserView";
import AdminUserGroupListView from "./admin/AdminUserGroupListView";
import UserGroupView from "./admin/UserGroupView";
import React, {Fragment} from "react";
import {Home} from "../Home";
import UserAttributeListView from "./userAttributes/UserAttributeListView";
import UserAttributeView from "./userAttributes/UserAttributeView";
import UserListView from "./user/UserListView";
import UserView from "./user/UserView";
import UserBatchActions from "./batch/UserBatchActions";
import TicketView from "./tickets/TicketView";
import TicketCreate from "./tickets/TicketCreate";
import TicketListView from "./tickets/TicketListView";
import {EditUserView} from "./user/EditUserView";
import AdminChartListView from "./charts/AdminChartListView";
import AdminChartView from "./charts/AdminChartView";
import AccountListView from "./account/AccountListView";
import AccountView from "./account/AccountView";

import EditAccountView from "./account/EditAccountView";
import TransactionView from "./account/TransactionView";
import MultiBalanceAccountView from "./multibalance/MultiBalanceAccountView";

import CasinoCategoryListView from "./casino/CasinoCategoryListView";
import CasinoCategoryView from "./casino/CasinoCategoryView";

import PaymentsListView from "./payments/PaymentsListView";
import PaymentView from "./payments/PaymentView";
import PaymentSettingEdit from "./payments/PaymentSettingEdit";
import PaymentSettingsListView from "./payments/PaymentSettingsListView";
import SettingsGeneralView from "./admin/SettingsGeneralView";
import {SettingsTransferLimitsView} from "./admin/SettingsTransferLimitsView";
import {BundlesListView} from "./store/BundlesListView";
import {BundleView} from "./store/BundleView";
import SettingsUserView from "./admin/SettingsUserView";
import SettingsInternalView from "./admin/SettingsInternalView";
import SupportedCurrenciesListView from "./account/SupportedCurrenciesListView";
import CreateOrUpdateCurrencyView from "./account/CreateOrUpdateCurrencyView";
import {AffiliatesSettingsView} from "./affiliates/AffiliatesSettingsView";
import {AffiliateListView} from "./affiliates/AffiliateListView";
import AffiliateView from "./affiliates/AffiliateView";
import AffiliateEditView from "./affiliates/AffiliateEditView";
import AffiliatesReportRevenueView from "./affiliates/AffiliatesReportRevenueView";
import AffiliatesReportPayoutsView from "./affiliates/AffiliatesReportPayoutsView";

import CasinoStudioListView from "./casino/CasinoStudioListView";
import EditCasinoStudioView from "./casino/EditCasinoStudioView";
import {CasinoGameListView} from "./casino/CasinoGameListView";
import EditCasinoGameView from "./casino/EditCasinoGameView";
import {CasinoGameTagListView} from "./casino/CasinoGameTagListView";
import {EditCasinoGameTag} from "./casino/EditCasinoGameTag";
import SettingsPWAView from "./admin/SettingsPWAView";
import TranslationsListView from "./translations/TranslationsListView";


import {CssStyling} from "../guides/styling/CssStyling";
import {CMSGuide} from "../guides/styling/CMSGuide";
import NotificationsView from "./notifications/NotificationsView";
import SettingsNotificationsView from "./admin/SettingsNotificationsView";
import SettingsIntegrationsView from "./admin/SettingsIntegrationsView";
import ProviderInfoView from "./admin/ProviderInfoView";
import {CreateBatchTransactionView} from "./batch/CreateBatchTransactionView";
import {BatchTransactionView} from "./batch/BatchTransactionView";
import ReportManagerView from "./report/ReportManagerView";
import MetabaseDashboardListView from "./report/MetabaseDashboardListView";
import MetabaseDashboardView from "./report/MetabaseDashboardView";
import MetabaseReportView from "./report/MetabaseReportView";
import AmplitudeManagerView from "./report/AmplitudeManagerView";
import TurnoverContributionsListView from "./bonus/TurnoverContributionsListView";
import {EditTurnoverContributions} from "./bonus/EditTurnoverContributions";
import MonetaryConfigListView from "./bonus/MonetaryConfigListView";
import EditMonetaryConfig from "./bonus/EditMonetaryConfig";
import EditOfferRule from "./bonus/EditOfferRule";
import OfferRuleListView from "./bonus/OfferRuleListView";
import EditBonusConfig from "./bonus/EditBonusConfig";
import BonusConfigListView from "./bonus/BonusConfigListView";
import BonusOfferListView from "./bonus/BonusOfferListView";
import {EditBonusOffer} from "./bonus/EditBonusOffer";
import AuditLogListView from "./audit/AuditLogListView";
import PlayerAuditListView from "./audits/PlayerAuditListView";
import {AuditLogView} from "./audit/AuditLogView";
import {SystemEventLogView} from "./audit/SystemEventLogView";
import {SystemEventListView} from "./audit/SystemEventListView";
import UserLabelListView from "./userLabels/UserLabelListView";
import EditUserLabelView from "./userLabels/EditUserLabelView";
import {UserBonusesView} from "./bonus/UserBonusView";
import { ContestsListView } from "./contests/ContestListView";
import { ContestTypeListView } from "./contests/ContestTypeListView";
import SettingLimitListView from "./bonus/SettingLimitListView";
import EditSettingLimit from "./bonus/EditSettingLimit";
import ManualBonusAwardListView from "./audit/ManualBonusAwardListView";
import PlayerUpdateListView from "./audit/PlayerUpdateListView";
import PlayerProductUpdateListView from "./audit/PlayerProductUpdateListView";
import PlayerMfaDisabledListView from "./audit/PlayerMfaDisabledListView";
import PlayerBlockedUpdateListView from "./audit/PlayerBlockedUpdateListView";
import CreditListView from "./credit/CreditListView";
import AdminUserLoginListView from "./audit/AdminUserLoginListView";
import BonusUpdateListView from "./audit/BonusUpdateListView";
import PaymentUpdateListView from "./audit/PaymentUpdateListView";
import ManualBonusBalanceAdjustmentListView from "./audit/ManualBonusBalanceAdjustmentListView";
import CreditCreate from "./credit/CreditCreate";
import CreditView from "./credit/CreditView";
import BetsListView from "./sportsbetting/BetsListView";
import { BetView } from "./sportsbetting/BetView";
import BetLogsListView from "./sportsbetting/BetLogsListView";
import { BetLogView } from "./sportsbetting/BetLogView";
import ClawbackReview from "./credit/ClawbackReview";


export const Routes = ( props : {}) => (
    <Fragment>
        <Route exact path="/" component={Home}/>
        <Route path="/admin/admin-users" component={AdminUserListView}/>
        <Route exact path="/admin/admin-user/:id" component={AdminUserView}/>
        <Route path="/admin/user-groups" component={AdminUserGroupListView}/>
        <Route path="/admin/user-group/:id" component={UserGroupView}/>
        <Route path="/admin/settings/general" component={SettingsGeneralView}/>
        <Route path="/admin/settings/integrations" component={SettingsIntegrationsView}/>
        <Route path="/admin/settings/transferLimits" component={SettingsTransferLimitsView}/>
        <Route path="/admin/settings/user" component={SettingsUserView}/>
        <Route path="/admin/settings/internal" component={SettingsInternalView}/>
        <Route path="/admin/settings/pwa" component={SettingsPWAView}/>
        <Route path="/admin/settings/notifications" component={SettingsNotificationsView}/>
        <Route path={"/user-attributes"} component={UserAttributeListView} />
        <Route path={"/user-attribute/:id"} component={UserAttributeView} />
        <Route path={"/users"} component={UserListView} />
        <Route path={"/tickets/list"} component={TicketListView} />
        <Route exact={true} path={"/tickets/new"} component={TicketCreate} />
        <Route exact={true} path={"/ticket/:id"} component={TicketView} />
        <Route path={"/payments"} component={PaymentsListView} />
        <Route path={"/payment-settings/list"} component={PaymentSettingsListView} />
        <Route path={"/payment-setting/:id"} component={PaymentSettingEdit} />
        <Route exact path={"/user/batch/actions"} component={UserBatchActions} />
        <Route exact path={"/user/edit/:id"} component={EditUserView} />
        <Route exact path={"/user/:id"} component={UserView} />
        <Route path={"/admin-charts/"} component={AdminChartListView} />
        <Route path={"/admin-chart/:id"} component={AdminChartView} />
        <Route path={"/audit-logs"} component={AuditLogListView} />
        <Route path={"/audit-logs-manual-bonus-award"} component={ManualBonusAwardListView} />
        <Route path={"/audit-logs-payment-update"} component={PaymentUpdateListView} />
        <Route path={"/audit-logs-manual-balance-adjustment"} component={ManualBonusBalanceAdjustmentListView} />
        <Route path={"/audit-logs-player-update"} component={PlayerUpdateListView} />
        <Route path={"/audit-logs-player-product-update"} component={PlayerProductUpdateListView} />
        <Route path={"/audit-logs-player-mfa-disabled"} component={PlayerMfaDisabledListView} />
        <Route path={"/audit-logs-player-blocked-update"} component={PlayerBlockedUpdateListView} />
        <Route path={"/audit-logs-admin-user-login"} component={AdminUserLoginListView} />
        <Route path={"/audit-logs-bonus-update"} component={BonusUpdateListView} />
        <Route path={"/analytics-logs"} component={PlayerAuditListView} />
        <Route exact path={"/audit-log/:id"} component={AuditLogView} />
        <Route path={"/system-events"} component={SystemEventListView} />
        <Route exact path={"/system-event/:id"} component={SystemEventLogView} />
        <Route path={"/accounts"} component={AccountListView} />
        <Route path={"/credits"} component={CreditListView} />
        <Route exact path={"/credit/review/:id"} component={ClawbackReview} />
        <Route exact path={"/credit/:id"} component={CreditView} />
        <Route exact path={"/credit/new"} component={CreditCreate} />
        <Route exact path={"/account/:id"} component={AccountView} />
        <Route exact path={"/multibalance-account/:id/:currencyCode/:username"} component={MultiBalanceAccountView} />
        <Route exact  path={"/account/edit/:id"} component={EditAccountView} />
        <Route exact  path={"/transaction/:id"} component={TransactionView} />
        <Route exact  path={"/currencies/list"} component={SupportedCurrenciesListView} />
        <Route exact  path={"/currencies/edit/:id"} component={CreateOrUpdateCurrencyView} />
        <Route path={"/casino-categories"} component={CasinoCategoryListView} />
        <Route path={"/bonus/turnover-contribution/list"} component={TurnoverContributionsListView} />
        <Route path={"/bonus/turnover-contributions/:id"} component={EditTurnoverContributions} />
        <Route path={"/bonus/configs/list"} component={BonusConfigListView} />
        <Route path={"/bonus/config/:id"} component={EditBonusConfig} />
        <Route path={"/bonus/offers/list"} component={BonusOfferListView} />
        <Route path={"/bonus/offer/:id"} component={EditBonusOffer} />
        <Route path={"/bonus/monetary-configs/list"} component={MonetaryConfigListView} />
        <Route path={"/bonus/monetary-config/:id"} component={EditMonetaryConfig} />
        <Route path={"/bonus/offer-rules/list"} component={OfferRuleListView} />
        <Route path={"/bonus/offer-rule/:id"} component={EditOfferRule} />
        <Route path={"/bonus/setting-limits/list"} component={SettingLimitListView} />
        <Route path={"/bonus/setting-limit/:id"} component={EditSettingLimit} />
        <Route exact path={"/casino-category/:id"} component={CasinoCategoryView} />
        <Route path={"/casino-studios"} component={CasinoStudioListView} />
        <Route path={"/casino-game-tags"} component={CasinoGameTagListView} />
        <Route exact path={"/casino-game-tag/:id"} component={EditCasinoGameTag} />
        <Route path={"/casino-games"} component={CasinoGameListView} />
        <Route exact path={"/casino-game/:id"} component={EditCasinoGameView} />
        <Route exact path={"/casino-studio/:id"} component={EditCasinoStudioView} />
        <Route exact path={"/payment/:id"} component={PaymentView} />
        <Route exact path="/bundles" component={BundlesListView}/>
        <Route exact path="/bundles/:id" component={BundleView}/>
        <Route exact path="/affiliates/settings" component={AffiliatesSettingsView}/>
        <Route exact path="/affiliates/" component={AffiliateListView}/>
        <Route exact path="/affiliates/user/:id" component={AffiliateView}/>
        <Route exact path="/affiliates/user/edit/:id" component={AffiliateEditView}/>
        <Route exact path="/affiliates/reports/revenue" component={AffiliatesReportRevenueView}/>
        <Route path="/affiliates/reports/payouts" component={AffiliatesReportPayoutsView}/>
        <Route exact path="/translations" component={TranslationsListView}/>
        <Route exact path="/guides/styling" component={CssStyling}/>
        <Route exact path="/guides/cms" component={CMSGuide}/>
        <Route exact path="/notifications" component={NotificationsView}/>
        <Route exact path="/integrations" component={ProviderInfoView}/>
        <Route exact path="/create-batch" component={CreateBatchTransactionView}/>
        <Route exact path="/batch-transaction/:id" component={BatchTransactionView}/>
        <Route exact path="/report/manage" component={ReportManagerView}/>
        <Route exact path="/analytics/amplitude" component={AmplitudeManagerView}/>
        <Route exact path="/metabase/dashboards" component={MetabaseDashboardListView}/>
        <Route exact path="/metabase/dashboard/:id" component={MetabaseDashboardView}/>
        <Route exact path="/metabase/report/:id" component={MetabaseReportView}/>
        <Route path={"/user-labels/list"} component={UserLabelListView} />
        <Route exact path={"/user-label/:id"} component={EditUserLabelView} />
        <Route path={"/user-labels/new"} component={EditUserLabelView} />
        <Route path={"/user-bonus/:id/user/:userId"} component={UserBonusesView} />
        <Route path={"/contest-types/list"} component={ContestTypeListView} />
        <Route path={"/contests/list"} component={ContestsListView} />
        <Route path={"/sportsbetting/bets/list"} component={BetsListView} />
        <Route path={"/sportsbetting/bet/:id"} component={BetView} />
        <Route path={"/sportsbetting/bet-logs/list"} component={BetLogsListView} />
        <Route path={"/sportsbetting/bet-log/:id"} component={BetLogView} />
    </Fragment>
)